import SiteVideo from "./SiteVideo";

export const instance = new SiteVideo();

export default { instance };
